import axios from 'axios';

export default {
    name: 'get-code',
    // Initial props provided by Login.vue.
    props: ['user', 'token'],
    // Initial data.
    data() {
        return {
            username: this.user.username,
            validationRadio: '',
            options: [
                {
                    value: 'email',
                    isVisible: this.user.hasOwnProperty('email'),
                    label: this.$t('HC_SEND_CODE_VIA_EMAIL').replace(
                        '{email}',
                        '<strong>' + this.user.email + '</strong>'
                    )
                },
                {
                    value: 'phone',
                    isVisible: this.user.hasOwnProperty('phone'),
                    label: this.$t('HC_SEND_CODE_VIA_TEXT').replace(
                        '{phone}',
                        '<strong>' + this.user.phone + '</strong>'
                    )
                }
            ],
            buttonClasses: ['is-fullwidth'],
            loadingState: false
        };
    },
    computed: {
        isCompleted() {
            let completed =
                this.validationRadio === 'phone' ||
                this.validationRadio === 'email';
            return completed;
        },
        // Only show options available. For example: If user only has phone number, show just phone option
        showOptionsAvailable() {
            return this.options.filter(function(option) {
                return option.isVisible;
            });
        }
    },
    // Methods needed for this component.
    methods: {
        // Transition to LoginForm component on Back to Login click.
        onClickBackToLogin(e) {
            e.preventDefault();
            this.$emit('currentView', 'login-form');
            this.$emit('currentTransition', 'component-slide-fade-down');
            this.$emit('currentAlert', null);
        },
        // Handle send of code based on button click.
        onClickSendCode(delivery) {
            // Add the loading spinner icon to the button.
            this.loadingState = true;

            // Add the loading spinner icon to the button.
            this.buttonClasses.push('button-loading');

            // Hit the API for sending the code.
            axios
                .get(
                    `${
                        process.env.VUE_APP_QV4_API
                    }/users/verification-code?username=${
                        this.user.username
                    }&sendBy=${delivery}`,
                    {
                        headers: {
                            'x-api-key': this.token
                        }
                    }
                )
                // If sent successfully, transition to the EnterCode component.
                .then(() => {
                    this.$emit('sentVia', delivery);
                    this.$emit('currentView', 'enter-code');
                    this.$emit(
                        'currentTransition',
                        'component-slide-fade-left'
                    );
                    this.$emit('currentAlert', null);
                })
                // If sending the code failed.
                .catch(() => {
                    // Remove loading spinner on button
                    this.loadingState = false;

                    let alert = {
                            message: this.$t('HC_OOPS_SOMETHING_WENT_WRONG'),
                            status: 'danger',
                            icon: 'exclamation-circle-outline'
                        },
                        index = this.buttonClasses.indexOf('button-loading');

                    // Remove loading spinner icon from button.
                    if (index > -1) {
                        this.buttonClasses.splice(index, 1);
                    }

                    // Send alert data to parent component.
                    this.$emit('currentAlert', alert);
                });
        }
    }
};
